import React from 'react';
import PropTypes from 'prop-types';
import { copyToClipboard } from 'utils/svgConstants';

function CopyToClipboardButton({ textToCopy = '', className = '', style = {} }) {
  const copySnippetText = () => {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(textToCopy)
        .then(() => { alert('Successfully copied the embeddable form snippet!'); }) // eslint-disable-line no-alert
        .catch((err) => { console.log('Failed to copy to clipboard', err); }); // eslint-disable-line no-console
      return;
    }
    alert('Your browser does not support copying to the clipboard.'); // eslint-disable-line no-alert
  };

  const buttonStyle = {
    ...style,
    // h and w are locked to match the SVG
    height: '2rem',
    width: '2rem',
  };

  return (
    <button
      type="button"
      className={className}
      style={buttonStyle}
      onClick={copySnippetText}
      aria-label="Copy snippet to clipboard"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" width="20" height="20" viewBox="10 30 512 512" aria-hidden="true" focusable="false">
        <title>Copy Snippet To Clipboard</title>
        <rect x="128" y="128" width="336" height="336" rx="57" ry="57" fill="none" stroke="white" strokeLinejoin="round" strokeWidth="32" />
        <path d={copyToClipboard} fill="none" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" />
      </svg>
    </button>
  );
}

CopyToClipboardButton.propTypes = {
  textToCopy: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default CopyToClipboardButton;
